import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';

import {ApplicationState} from '../../application-state/store';
import {CustomerCommentTagsActions} from '../store';
import {CustomerCommentTagsSelectors} from '../store/selectors';

@Injectable()
export class CustomerCommentTagsLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadCustomers().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadCustomers(): Observable<any> {
    return this.store.pipe(
      select(CustomerCommentTagsSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(CustomerCommentTagsActions.LoadCustomerCommentTags());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
